import React, { Component } from "react"
import { connect } from "react-redux"
import {
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  RadialBarChart,
  RadialBar
} from "recharts"

import * as actions from "../actions"

import gadata from "../data/outcomes.json"

const data = [
  {
    name: "Exchange Event, Managing Change",
    Played: 2,
    Complete: 1
  },
  {
    name: "Fortune Favours the Brave",
    Played: 3,
    Complete: 1
  },
  {
    name: "Getting The Best Out of You and Your Team",
    Played: 1,
    Complete: 1
  },
  {
    name: "Member Event with Ajaz Ahmed, Freeserve",
    Played: 1,
    Complete: 1
  },
  {
    name: "Member Event with Charlie Hoult",
    Played: 4,
    Complete: 1
  },
  {
    name: "Member Event with Julian Leighton, Orange Bus",
    Played: 2,
    Complete: 1
  }
]

class Feature extends Component {
  componentWillMount() {
    this.props.fetchMessage()
  }

  render() {
    return (
      <div>
        <h1>Entrepreneurs' Forum Mobile App CMS</h1>
        {/* <h1>Outcomes Dashboard</h1>

        <h2>Video Outcomes</h2>
        <BarChart width={730} height={250} data={data}>
          <XAxis dataKey="name" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend />
          <Bar dataKey="Played" fill="#CA8FC0" />
          <Bar dataKey="Complete" fill="#961B81" />
        </BarChart> */}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { message: state.auth.message }
}

export default connect(mapStateToProps, actions)(Feature)



/** WEBPACK FOOTER **
 ** ./src/components/dashboard.js
 **/